import { render, staticRenderFns } from "./FormImagingCategoryMap.vue?vue&type=template&id=849961a2&scoped=true"
import script from "./FormImagingCategoryMap.vue?vue&type=script&lang=js"
export * from "./FormImagingCategoryMap.vue?vue&type=script&lang=js"
import style0 from "./FormImagingCategoryMap.vue?vue&type=style&index=0&id=849961a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849961a2",
  null
  
)

export default component.exports